import React, { useContext } from 'react'
// import { NavLink } from "react-router-dom";
import Web3context from '../contexts/Web3context.js'

import abi_1155 from '../contracts/IERC1155Game.json'

const PantryItem = (props) => {
  // if no data redirect to ingredients
  if (!props.location.data) {
    window.location = "/ingredients"
  }

  // Call web3 model init
  const web3context = useContext(Web3context);
  let { getWeb3 } = web3context;

  // buy Item function
  const buyItem = async () => {
    try {
      const web3 = getWeb3;
      const item = props.location.data;

      console.log("Network Id is", await web3.eth.net.getId());
      const accounts = await web3.eth.getAccounts();
      const contract_1155 = await new web3.eth.Contract(abi_1155.abi, "0xebe32c46234cA88A373a42Ed3916a7222B3E6BB0");
      
      const txnhash = await contract_1155.methods.buyIngredientNFT(item.id, item.tname)
        .send({ from: accounts[0], gasPrice: "1000000000", gas: 35000 });
      console.log(txnhash);

    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="productDetails_page">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="productImages">
              <img src="assets/images/tomato-big.svg" alt="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="productContent">
              <h1>{props.location.data.name}</h1>
              <h3>1 ETH</h3>
              <h2>DESCRIPTION</h2>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud </p>
              <button onClick={buyItem}>Buy now</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PantryItem;
